export { default } from './ModalMobileLayout.js';
